/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { User } from '../../../../../models/User';
import { ParamValueModel } from '../../../../../models/ParamValueModel';
import { ApigeeService } from '../../../../../services/apigee.service';
import { ScrollTriggerService } from 'app/services/scroll-trigger.service';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-domain-info',
  templateUrl: './domain-info.component.html',
  styleUrls: ['./domain-info.component.scss']
})
export class DomainInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() domain: string;
  @Input() data: any;
  @Input() loading: boolean;
  @Input() isFollowing: boolean;
  @Input() numWatching = -1;
  @Input() processingFollow: boolean;

  @Output() toAppDiscovery: EventEmitter<ParamValueModel> =
    new EventEmitter<ParamValueModel>();
  @Output() followButtonBreakpointReached: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() followButtonClick: EventEmitter<Event> = new EventEmitter<Event>();

  @ViewChild('followButton') followButton: ElementRef<HTMLElement>;

  viewCount = -1;
  destroyToken: Subject<void>;

  handleError(event) {
    event.target.src =
      'https://www.google.com/s2/favicons?domain=' +
      this.data?.overview?.adDomain +
      '&sz=48';
  }

  constructor(
    public _userService: User,
    private _apigeeService: ApigeeService,
    private _scrollTrigger: ScrollTriggerService
  ) {}

  ngOnInit() {
    this.destroyToken = new Subject();
  }

  ngAfterViewInit(): void {
    this.getNumViewing();

    this._scrollTrigger.callback$
      .pipe(
        takeUntil(this.destroyToken),
        map(() => {
          console.assert(
            this.followButton,
            'no follow button reference defined on the page'
          );
          const elBottom =
            this.followButton.nativeElement.getBoundingClientRect().bottom;

          return elBottom < 0;
        })
      )
      .subscribe(value => {
        this.followButtonBreakpointReached.emit(value);
      });
  }

  ngOnDestroy() {
    this.destroyToken.next();
    this.destroyToken.complete();
  }

  getNumViewing() {
    this.viewCount = -1;
    this._apigeeService
      .getNumViewingById(this.domain, 'domains')
      .then(response => {
        this.viewCount = response['views'];
      })
      .catch(() => {
        this.viewCount = 0;
      });
  }

  goToAppDiscovery(param: string, paramValue: string) {
    this.toAppDiscovery.emit({ param: param, paramValue: paramValue });
  }
}
